import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaTablet } from 'utils/styles/responsive';

export const Wrapper = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 328rem;

  ${mediaTablet(`
    grid-row-gap: 904rem;
  `)}
`;

export const SideTextContainer = styled(motion.li)``;
